import { customTheme } from '../../../../../theme';

import { ICardStyles } from './index';

export const defaultCardStyle: ICardStyles = {
  card: {
    px: 4,
    pb: 4,
    w: 'full',
    h: 'full',
    position: 'relative',
    border: '2px solid',
    borderColor: 'transparent',
    borderWidth: '1px',
    rounded: customTheme.radii.cardBorderRadius,
    direction: 'column' as any,
    bg: 'cardBg',
  },
  header: {
    //fontSize: 'xl',
    pt: 4,
    pos: 'sticky',
    top: 0,
    zIndex: 10,
    bg: 'cardBg',
    pb: 4,
  },
  cardContent: { flex: 1, m: 0 },
  footer: {
    pt: 3,
    bottom: 0,
    left: 0,
    right: 0,
    bg: 'transparent',
    w: 'full',
    rounded: customTheme.radii.cardBorderRadius,
  },
};
